import React, { useState } from "react";
import FindProductsForm from "./find-products-form/FindProductsForm";
import Typography from "@material-ui/core/Typography";
import Stepper from "@material-ui/core/Stepper";
import ProductsSwapSummary from "./products-swap-summary/ProductsSwapSummary";
import { makeStyles } from "@material-ui/core/styles";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";

import "./ProductSwap.css";
import Alert from "./alert/Alert";
import ProductsTable from "./products-table/ProductsTable";
import axios from "../../security/axios";

const useStyles = makeStyles((theme) => ({
    stepper: {
        padding: theme.spacing(3, 0, 5),
    }
}));

const FIND_PRODUCTS_FOR_CUSTOMER = 0;
const SELECT_PRODUCTS_TO_SWAP = 1;
const PERFORM_PRODUCTS_SWAP = 2;

const steps = ['Find products for customer', 'Select products to swap', 'Perform products swap'];

const ProductSwap = () => {
    const [email, setEmail] = useState("");
    const [products, setProducts] = useState([]);
    const [allProducts, setAllProducts] = useState([]);
    const [oldProduct, setOldProduct] = useState(null);
    const [newProduct, setNewProduct] = useState(null);
    const [activeStep, setActiveStep] = useState(FIND_PRODUCTS_FOR_CUSTOMER);
    const [resultMessage, setResultMessage] = useState(null);
    const classes = useStyles();

    const onSubmitFindProductCallback = async () => {
        const userProducts = await axios.get(encodeURI(`/products?email=${email}`));
        setProducts(userProducts.data);
        const allProducts = await axios.get('/products');
        setAllProducts(allProducts.data);
        setResultMessage(null);
        setActiveStep(SELECT_PRODUCTS_TO_SWAP);
    };

    const onConfirmSwapCallback = async () => {
        console.log(`Update from ${oldProduct?.name} to ${newProduct?.name} finished`);

        try {
            const result = await axios.post(`/swap-products`, {
                email,
                oldProductId: oldProduct.id,
                newProductId: newProduct.id,
            });
            console.log(result);
            const { data: responseData } = result;

            if (result.status !== 200) {
                setResultMessage([{ success: false, msg: 'Server error occurred during product swap' }])
            }

            const message = [
                { success: responseData.data.database.success, msg: responseData.data.database.message },
                // { success: responseData.data.learnWorlds.success, msg: responseData.data.learnWorlds.message },
                // { success: responseData.data.iterable.success, msg: responseData.data.iterable.message }
            ]
            setResultMessage(message)


        } catch (e) {
            setResultMessage([{ success: false, msg: `Error occurred during product swap: ${e}` }])
            setActiveStep(FIND_PRODUCTS_FOR_CUSTOMER);
            setOldProduct(null);
            setNewProduct(null);
        }
    };

    const getStepContent = (step) => {
        switch (step) {
            case FIND_PRODUCTS_FOR_CUSTOMER:
                return <FindProductsForm email={email}
                    onSubmitCallback={onSubmitFindProductCallback}
                    onChange={setEmail} />;
            case SELECT_PRODUCTS_TO_SWAP:
                return <ProductsTable userProducts={products} allProducts={allProducts}
                    oldProduct={oldProduct} setOldProduct={setOldProduct}
                    newProduct={newProduct} setNewProduct={setNewProduct}
                    onSubmitCallback={() => setActiveStep(PERFORM_PRODUCTS_SWAP)}
                    onBack={() => setActiveStep(activeStep - 1)} />;
            case PERFORM_PRODUCTS_SWAP:
                return <ProductsSwapSummary newProduct={newProduct}
                    oldProduct={oldProduct}
                    onBack={() => setActiveStep(activeStep - 1)}
                    onSubmitCallback={onConfirmSwapCallback}
                    customerEmail={email} />;
            default:
                throw new Error("Unknown step");
        }
    };

    return (
        <section>
            <div className="ml-1">
                <Typography variant="h5">
                    Product Swap
                </Typography>
            </div>
            {(resultMessage && resultMessage.length > 0) && (
                <div className="mt-25 ml-1 mr-1">
                    {resultMessage.map(e =>
                        <Alert severity={e.success ? "success" : "error"} onClose={() => setResultMessage(null)}>
                            {e.msg}
                        </Alert>)
                    }
                </div>
            )}
            <div className="ml-1 mr-1 mt-25">
                <Stepper activeStep={activeStep} className={classes.stepper}>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <div className="ml-1">
                    {getStepContent(activeStep)}
                </div>
            </div>
        </section>
    );
};

export default ProductSwap;